import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "footer-area pt-100 pb-75" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col-lg-4",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_5 = { class: "footer-single-widget mw-250" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "ps-0 mb-0 list-unstyled d-flex social-links" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "footer-single-widget" }
const _hoisted_12 = { class: "ps-0 mb-0 list-unstyled import-links" }
const _hoisted_13 = {
  class: "col-xl-3 col-sm-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "400"
}
const _hoisted_14 = { class: "footer-single-widget" }
const _hoisted_15 = { class: "ps-0 mb-0 list-unstyled contact-links" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_RouterLink, {
              to: "/",
              class: "d-inline-block footer-logo"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _ctx.footerData.logo,
                  alt: "white-logo"
                }, null, 8, _hoisted_6)
              ]),
              _: 1
            }),
            _createElementVNode("p", null, _toDisplayString(_ctx.footerData.description), 1),
            _cache[0] || (_cache[0] = _createElementVNode("h4", null, "وسائل التواصل الاجتماعي", -1)),
            _createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerData.socialLinks, (social) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: social.name
                }, [
                  _createElementVNode("a", {
                    href: social.url,
                    target: "_blank"
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(social.icon)
                    }, null, 2)
                  ], 8, _hoisted_8)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerData.sections, (section, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-xl-3 col-sm-6",
                "data-aos": "fade-up",
                "data-aos-duration": "1000",
                "data-aos-delay": "300"
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h3", null, _toDisplayString(section.title), 1),
                  _createElementVNode("ul", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.links, (link) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: link.text
                      }, [
                        _createVNode(_component_RouterLink, {
                          to: link.url
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(link.text), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[1] || (_cache[1] = _createElementVNode("h3", null, "تواصل معنا", -1)),
                _createElementVNode("ul", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerData.contact, (contact) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: contact.phone
                    }, [
                      _createElementVNode("a", {
                        href: 'tel:' + contact.phone
                      }, _toDisplayString(contact.phone), 9, _hoisted_16),
                      _createElementVNode("p", _hoisted_17, _toDisplayString(contact.note), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}